import React from "react";

interface NotificationModalProps {
  show: boolean;
  onClose: () => void;
  message: string;
}

const NotificationModal: React.FC<NotificationModalProps> = ({ show, onClose, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm">
      <div className="bg-black bg-opacity-70 text-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm border border-yellow-500">
        <h2 className="text-lg font-semibold text-yellow-400 mb-2">Notice</h2>
        <p className="text-sm text-gray-200 mb-4">{message}</p>
        <button
          onClick={onClose}
          className="bg-yellow-500 text-black px-4 py-2 rounded-lg font-semibold hover:bg-yellow-600 transition w-full"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default NotificationModal;
